module.exports = __webpack_public_path__ + "assets/img/china-Singaproebiaoge.a67c5a87.png";